import { render } from "./ChooseUser.vue?vue&type=template&id=6650eca2"
import script from "./ChooseUser.vue?vue&type=script&lang=js"
export * from "./ChooseUser.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__